export const vesselTypeToTranslationKey = (vesselType: number): string => {
  switch (true) {
    case vesselType === 0:
      return vesselType.toString();

    case vesselType >= 1 && vesselType <= 19:
      return "unknown";

    case vesselType >= 30 && vesselType <= 37:
      return vesselType.toString();

    case vesselType >= 38 && vesselType <= 39:
      return "unknown";

    case vesselType === 40:
      return vesselType.toString();

    case vesselType >= 50 && vesselType <= 59:
      return vesselType.toString();

    case vesselType === 60:
      return vesselType.toString();

    case vesselType === 70:
      return vesselType.toString();

    case vesselType === 80:
      return vesselType.toString();

    case vesselType === 90:
      return vesselType.toString();

    case vesselType > 99:
      return "unknown";

    default:
      return "unknown";
  }
};
